export default "__VITE_ASSET__fbShzSgH__"